import Store from '@ember-data/store';
import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import PledgeModel from 'donor-elf-web/models/pledge';
import YtdNextYearProjectionModel from 'donor-elf-web/models/ytd-next-year-projection';
import FundsService from 'donor-elf-web/services/funds-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validateNumber } from 'ember-changeset-validations/validators';

const projectionValidation = {
  goal: validateNumber({ message: 'Needs to be a number' }),
};

export interface YtdNextYearProjectionRouteModel {
  record: YtdNextYearProjectionModel;
  pledgesById: { [pledgeId: string]: PledgeModel };
  changeset: any;
}

export default class YtdNextYearProjectionRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;
  @service declare router: RouterService;

  beforeModel() {
    this.navbarSettings.title = 'Next Year Projection';
  }

  async model(): Promise<YtdNextYearProjectionRouteModel | undefined> {
    try {
      let record = await this.store.findRecord(
        'ytd-next-year-projection',
        this.fundsService.selectedFund!.id,
      );
      let pledgesById: any = {};
      record.pledges.forEach((pledge) => {
        pledgesById[pledge.id] = pledge;
      });
      let changeset = new Changeset(
        record,
        lookupValidator(projectionValidation),
        projectionValidation,
      );

      return {
        record,
        pledgesById,
        changeset,
      };
    } catch (e) {
      if (e.errors?.[0]?.status === '404') {
        this.router.transitionTo('funds.fund.ytd-next-year-projection-no-goal');
        return;
      } else {
        throw e;
      }
    }
  }

  @action
  refreshYtdNextYearProjectionRoute() {
    this.refresh();
  }
}
